import { LeaderboardData, MultiLeaderboardData } from '~/Leaderboard/types/leaderboard.types'
import { homApi } from '~/redux/apis/hom'
import { USER_API_TAGS } from '~/redux/constants/tags.const'

export const leaderboardApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    getLeaderboardData: builder.query<LeaderboardData, void>({
      query: () => ({
        url: '/v1/leaderboard',
        method: 'GET',
      }),
      providesTags: [USER_API_TAGS.LeagueParticipation],
    }),

    getFamilyMemberLeaderboard: builder.query<LeaderboardData, { familyMemberId: number | undefined }>({
      query: ({ familyMemberId }) => ({
        url: `/v1/leaderboard/family-member-leaderboard?familyMemberId=${familyMemberId}`,
        method: 'GET',
      }),
      providesTags: [USER_API_TAGS.LeagueParticipation],
    }),
    getCurrentLeague: builder.query<{ currentLeague: number; highestLeague: number }, void>({
      query: () => ({
        url: '/v1/leaderboard/my-league',
        method: 'GET',
      }),
      providesTags: [USER_API_TAGS.LeagueParticipation],
    }),

    getCustomLeagueInfo: builder.query<
      Array<{ id: number; nickname: string; avatarPngUrl: string; xp: number }>,
      { userIds: number[]; startDate?: string; endDate?: string }
    >({
      query: (body) => ({
        url: '/v1/leaderboard/custom-league',
        method: 'post',
        body,
      }),
      providesTags: [USER_API_TAGS.LeagueParticipation],
    }),
    getAccentureLeaderboard: builder.query<
      {
        data: { createdAt: string; id: number; leaderboardData: MultiLeaderboardData[]; updatedAt: string }
        success: boolean
      },
      void
    >({
      query: () => ({
        url: '/v1/leaderboard/accenture',
        method: 'GET',
      }),
    }),
    setAccentureLeaderboard: builder.mutation<unknown, void>({
      query: () => ({
        url: '/v1/leaderboard/accenture',
        method: 'POST',
      }),
    }),
    hasCampaignLeaderboard: builder.query<{ campaignName: string }, void>({
      query: () => ({
        url: '/v1/campaigns/campaign-name',
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useGetLeaderboardDataQuery,
  useGetFamilyMemberLeaderboardQuery,
  useGetCurrentLeagueQuery,
  useGetCustomLeagueInfoQuery,
  useGetAccentureLeaderboardQuery,
  useSetAccentureLeaderboardMutation,
  useHasCampaignLeaderboardQuery,
} = leaderboardApi
